import * as React from "react";
import { cn } from "@/lib/utils";

export interface SwitchProps
	extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "onChange"> {
	checked?: boolean;
	onCheckedChange?: (checked: boolean) => void;
}

const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
	({ className, checked = false, onCheckedChange, ...props }, ref) => {
		const handleToggle = (event: React.MouseEvent<HTMLButtonElement>) => {
			props.onClick?.(event);
			if (event.defaultPrevented) {
				return;
			}
			onCheckedChange?.(!checked);
		};

		return (
			<button
				type="button"
				role="switch"
				aria-checked={checked}
				data-state={checked ? "checked" : "unchecked"}
				ref={ref}
				className={cn(
					"inline-flex h-6 w-11 items-center rounded-full bg-muted shadow-sm transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-2 data-[state=checked]:bg-primary data-[state=checked]:border-primary",
					className
				)}
				onClick={handleToggle}
				{...props}
			>
				<span
					className={cn(
						"block h-5 w-5 translate-x-0 rounded-full bg-background shadow-sm transition-transform",
						checked ? "translate-x-5" : "translate-x-0.5"
					)}
				/>
			</button>
		);
	}
);

Switch.displayName = "Switch";

export { Switch };
